
import { defineComponent, onMounted, reactive, toRefs } from "vue";
import Header from "@/components/Header.vue";
import Bottom from "@/components/Bottom.vue";
import { useRoute } from "vue-router";
import { selNewsDetailById } from "@/api/index";
export default defineComponent({
  name: "newsDetail",
  props: ["titleId"],
  components: {
    Header,
    Bottom
  },
  setup() {
    const route = useRoute();

    const data = reactive({
      newDetail: {
        name: "",
        created_at: "",
        content: ""
      }
    });
    const selNewsDetail = async () => {
      if (route.query.articleId) {
        let params = {
          id: route.query.articleId
        };
        await selNewsDetailById(params).then((res: any) => {
          data.newDetail = res.data;
          data.newDetail.created_at = data.newDetail.created_at;
        });
      }
    };
    onMounted(() => {
      selNewsDetail();
    });
    return { ...toRefs(data) };
  }
});
